export enum SecurityServiceErrorCode {
  GENERAL,
}

export interface SecurityUser {
  CDate: string
  CField1: string
  CField2: string
  CField3: string
  CField4: string
  ClientID: number
  DefaultNode: string
  Enabled: number
  Expire: number
  ExpireDate: string
  Full_Name: string
  GroupID: number
  GroupName: string
  HashSum_UserID_: string
  ID: number
  InvalidCount: number
  IsUserRoamer: number
  LastLogon: string
  LastPasswdChange: string
  LockTimeout: string
  LoginFull: string
  NodeID: number
  Pass: string
  Privilege: number
  RL_Check: number
  User_Name: string
}

export interface SecurityServiceFailure {
  message: string
}

export type SecurityUsersServerData = SecurityUser[]

export interface SecurityGroup {
  AccSecLevel_Use: number
  AccSecLevel_View: number
  AuthFailCount: number
  AuthFailLockTimeout: number
  AutoCashAccounts: number
  ForceLogoff: number
  HashSum_GroupID_: string
  ID: number
  LFLSecLevel: number
  LimitSearchCrit: number
  LimitSearchEntryDTRange: number
  LimitSearchFields: string
  LimitSearchTop: number
  NotifyRateChange: number
  OTPKey: string
  OTPKeyDate: string
  OTPValidSec: number
  OVRD_USR: number
  PassComplex: string
  PassExpire: number
  PassHistoryCount: number
  PassLength: number
  RL_Check: number
  RL_Check_Client: number
  SHN_ShareDown: number
  Title: string
  WHCheck: number
}

export type SecurityGroupsServerData = SecurityGroup[]

export interface SecurityIPAccess {
  Comment: string
  GroupName: string
  HashSum_IPID_: string
  ID: number
  IPAddr: string
  LoginFull: string
  Netmask: number
  SEC_GroupID: number
  SEC_UserID: number
}

export type SecurityIPAccessesServerData = SecurityIPAccess[]

export type FirewallRule = 'allow' | 'deny'

export interface FirewallEntry {
  IP: string
  Mask: number
  Comment: string
  Expire: number
}

export type FirewallEntriesServerData = FirewallEntry[]

interface AddIpAdrressUser {
  User_Name: string
  Full_Name: string
  UserID: string
  HashSum_UserID_: string
  IPAddr: string
  Netmask: 0 | 8 | 16 | 32
  Comment?: string
}

interface AddIpAddressGroup {
  GroupID: string
  HashSum_GroupID_: string
  IPAddr: string
  Netmask: 0 | 8 | 16 | 32
  Comment?: string
}

export type AddIpAddressEntry = AddIpAdrressUser | AddIpAddressGroup

interface EditIpAddressUser {
  ID: string
  User_Name: string
  Full_Name: string
  UserID: string
  HashSum_UserID_: string
  IPAddr: string
  HashSum_IPID: string
  Netmask: 0 | 8 | 16 | 32
  Comment?: string
}

interface EditIpAddressGroup {
  ID: string
  IPAddr: string
  GroupID: string
  HashSum_GroupID_: string
  HashSum_IPID: string
  Netmask: 0 | 8 | 16 | 32
  Comment?: string
}

export type EditIpAddressEntry = EditIpAddressUser | EditIpAddressGroup

interface DeleteIpAddressUser {
  ID: string
  UserID: string
  HashSum_UserID_: string
  IPAddr: string
  HashSum_IPID: string
}

interface DeleteIpAdrressGroup {
  ID: string
  GroupID: string
  HashSum_GroupID_: string
  IPAddr: string
  HashSum_IPID: string
}

export type DeleteIpAddressEntry = DeleteIpAddressUser | DeleteIpAdrressGroup
